import React from 'react';

import { CustomizedTypography } from '@components/Customized';

import { IconButton } from '@material-ui/core';
import { ChevronLeftOutlined } from '@material-ui/icons';

import useDrawer from '../useDrawer';

import { menuListItems } from './menuListItems';

interface MenuDrawerHeaderBarProps {
  rightButton?: () => React.ReactNode;
}

const MenuDrawerHeaderBar = ({ rightButton }: MenuDrawerHeaderBarProps) => {
  const [drawer, updateDrawer] = useDrawer();
  return (
    <>
      <div className="drawer-header">
        <div className="drawer-close" onClick={() => updateDrawer('init')}>
          <IconButton className="close-button">
            <ChevronLeftOutlined />
          </IconButton>
          <CustomizedTypography variant="body1" color="textPrimary">
            닫기
          </CustomizedTypography>
        </div>

        <CustomizedTypography
          variant="body1"
          color="textPrimary"
          fontWeight="500"
        >
          {menuListItems.find((v) => v.menu === drawer.menu)?.name}
        </CustomizedTypography>

        {rightButton && rightButton()}
      </div>
      <div className="drawer-header empty" />
    </>
  );
};

export default MenuDrawerHeaderBar;
